import React from "react";

// Detailed robot bust in the ProFisc brand palette
// (bright green #0ae179, charcoal #2f3437, white).
// Self-contained SVG, no image asset needed.
// disc="mint" (default): light mint disc behind the robot, used inside the chat modal.
// disc="none": no disc, just the robot, used in the navbar.
const BotAvatar = ({ size = 24, className = "", showBg = false, disc = "mint" }) => {
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: showBg ? "#d9f2ec" : "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      <svg
        width={showBg ? size * 0.86 : size}
        height={showBg ? size * 0.86 : size}
        viewBox="0 0 96 96"
        fill="none"
        role="img"
        aria-label="Bot"
      >
        <defs>
          <linearGradient id="bot-headg" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#ffffff" />
            <stop offset="1" stopColor="#e6ebee" />
          </linearGradient>
          <linearGradient id="bot-screeng" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#15181b" />
            <stop offset="1" stopColor="#2b3137" />
          </linearGradient>
        </defs>
        {disc !== "none" && (
          <>
            <circle cx="48" cy="48" r="44" fill="#b8f5d9" />
            <circle cx="48" cy="48" r="39" stroke="#06b35f" strokeOpacity="0.3" strokeWidth="1.5" />
          </>
        )}

        {/* Body / shoulders */}
        <rect x="25" y="68" width="46" height="26" rx="11" fill="#c9d1d7" />
        <rect x="27" y="66" width="42" height="26" rx="10" fill="url(#bot-headg)" />
        <rect x="36" y="72" width="24" height="16" rx="5" fill="#dfe5e9" />
        <circle cx="48" cy="80" r="5.2" fill="#0ae179" />
        <circle cx="48" cy="80" r="7.6" stroke="#0ae179" strokeOpacity="0.4" strokeWidth="1.4" />

        {/* Neck */}
        <rect x="42" y="60" width="12" height="9" rx="3" fill="#aeb8bf" />

        {/* Antenna */}
        <rect x="46.7" y="14" width="2.6" height="12" rx="1.3" fill="#aeb8bf" />
        <circle cx="48" cy="12.5" r="4.2" fill="#0ae179" />
        <path d="M39.8 6.4q-3.2 2.6-3.8 7" stroke="#06b35f" strokeOpacity="0.5" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M56.2 6.4q3.2 2.6 3.8 7" stroke="#06b35f" strokeOpacity="0.5" strokeWidth="1.6" strokeLinecap="round" />

        {/* Ear modules */}
        <rect x="13.5" y="37" width="8" height="18" rx="4" fill="#2f3437" />
        <rect x="74.5" y="37" width="8" height="18" rx="4" fill="#2f3437" />
        <circle cx="17.5" cy="46" r="2.1" fill="#0ae179" />
        <circle cx="78.5" cy="46" r="2.1" fill="#0ae179" />

        {/* Head */}
        <rect x="21" y="25" width="54" height="40" rx="13" fill="url(#bot-headg)" />
        <path d="M34 25h28a13 13 0 0 1 12.7 10H21.3A13 13 0 0 1 34 25z" fill="#ffffff" />

        {/* Visor screen */}
        <rect x="28" y="32.5" width="40" height="23.5" rx="8.5" fill="url(#bot-screeng)" />

        {/* Eyes */}
        <rect x="37.4" y="38.6" width="5" height="10" rx="2.5" fill="#0ae179" />
        <rect x="53.6" y="38.6" width="5" height="10" rx="2.5" fill="#0ae179" />
        <circle cx="38.9" cy="40.4" r="1.1" fill="#ffffff" fillOpacity="0.85" />
        <circle cx="55.1" cy="40.4" r="1.1" fill="#ffffff" fillOpacity="0.85" />
        {/* Smile */}
        <path d="M41.5 50.6q6.5 4 13 0" stroke="#0ae179" strokeWidth="2" strokeLinecap="round" />

        {/* Chin detail */}
        <rect x="41" y="59" width="14" height="2.8" rx="1.4" fill="#cfd7dc" />
      </svg>
    </div>
  );
};

export default BotAvatar;
